var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
		`warranty-option`,
		{ 'checked': _vm.isActive }
	]},[_c('input',_vm._g({class:_vm.showRadioIcon ? 'radio-option' : 'radio-hidden',attrs:{"type":"radio","role":"radio","id":_vm.radioId,"name":_vm.radioGroupName,"disabled":_vm.radioDisabled},domProps:{"checked":_vm.isActive,"value":_vm.value},on:{"change":_vm.toggle}},_vm.$listeners)),_vm._v(" "),_c('label',{attrs:{"for":_vm.radioId}},[_vm._v("\n\t\t"+_vm._s(_vm.warranty.warrantyLength)+" Year Service Plan ($"+_vm._s(_vm.warranty.price.toCurrency())+")\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }